export default {
  namespaced: true,
  messages: {
    delete: {
      title: "¿Estas seguro de eliminarlo?",
      body: "Una vez eliminado se borraran todos los registros asociados",
      deleted_correctly: "Eliminado correctamente",
      title_n: "¿Estas seguro de eliminar {n} elementos?",
      all: "¿Estás seguro de borrar todo?",
    },
    reset: {
      title: "¿Estas seguro de resetar la contraseña?",
      counter_title: "Reiniciar Contador",
      counter: "¿Estás seguro de que quieres reiniciar el contador?",
    },
    error: {
      server_error: "Error obteniendo la información",
      task_not_assigned: "Error al asignar la tarea",
      max_files_exceeded: "Has excedido el número máximo de archivos permitidos"
    },
    success: {
      task_assigned: "Tarea asignada correctamente",
      task_completed: "Tarea marcada como realizada",
      alarm_reopened: "Alarma reabierta correctamente",
    },
    validation: {
      required: "El campo {field} es requerido",
      email_placeholder: "Ingresa uno o varios correos",
      missing_fields: {
        title: "Campos requeridos faltantes",
        text: "Por favor complete los siguientes campos: {fields}"
      }
    },
    info: {
      begin_download: "Iniciando proceso para exportar video...",
      in_process_download: "Se ha iniciado el proceso de forma correcta...",
      finish_download: "Se descargo grabacion correctamente",
      sending: "enviando",
      advanced_search: "búsqueda avanzada",
      clear_filters: "limpiar filtros",
      select: "seleccionar",
    },
    export: {
      title: "Exportar",
      download: "Descarga",
      Generating_file: "Generando archivo...",
      download_succesfully: "Descarga completa...",
      report_of: "Reporte de {model}",
      report: "Reporte de",
      full_download: "Descarga completa",
      downloading_file: 'Descargando archivo...',
    },
    edit_save: {
      successfully_created: "Creado correctamente",
      updated_successfully: "Editado correctamente",
      updated_successfully_withoutCameraUrl: "Editado correctamente sin actualizar la URL de la cámara",
    },
    copy: {
      copied_successfully: "Copiado correctamente",
      could_not_copy: "No se pudo copiar",
    },
    import: {
      title: "Importar",
      rems: "Importar archivo REMS",
      select_file: "Seleccione o arrastre y suelte el archivo",
      upload: "Subiendo",
      uploading_file: "Cargando archivo...",
      upload_succesfully: "Carga completa...",
      example_file: "Archivo de ejemplo",
    },
    loading: {
      title: "Cargando",
      document: "Cargando documento..."
    },
    redirect: {
      login: "Lo redirigiremos al inicio de sesión en 5 segundos."
    },
    greetings: {
      change_password: "Hola {name},"
    },
    session_expiration:{
      expiration: "La sesión esta apunto de expirar en",
      continue_session: "Continuar sesión"
    },
    session_lifetime: {
      lifetime_exceeded: "Has estado inactivo, la sesión se cerrará al llegar al tiempo límite.",
      continue_session: "Continuar sesión"
    },
    errors: {
      general: "Ha ocurrido un error",
      loading_document: "Error al cargar el documento",
      showing_document: "Error al mostrar el documento",
      loading_service_orders: "Error cargando órdenes de servicio"
    },
    processing: "procesando",
    activate: {
      title: "¿Estas seguro de activar ",
      body: "Si activas el dispositivo, podrás utilizarlo",
      activated_correctly: "Activado correctamente",
      activated_correctly_confirm: "Se ha activado correctamente el dispositivo",
      armed_correctly: "Armado correctamente",
      armed_correctly_confirm: "Se ha armado correctamente el dispositivo",
      error: "Error al activar",
      confirm: "Confirmar",
      activating: "Activando",
    },
    desactivate: {
      title: "¿Estas seguro de desactivar ",
      body: "Si desactivas el dispositivo, no podrás utilizarlo",
      confirm: "Desactivar",
      desactivated_correctly: "Desactivado correctamente",
      desactivated_correctly_confirm: "Se ha desactivado correctamente el dispositivo",
      disarmed_correctly: "Desarmado correctamente",
      disarmed_correctly_confirm: "Se ha desarmado correctamente el dispositivo",
      error: "Error al desactivar",
      deactivating: "Desactivando",
    },
    actions: {
      apply_state: "Aplicar estado",
      no_action_selected: "No se seleccionó ninguna acción",
      executing: "Ejecutando",
      in: "en",
      executed_successfully: 'Acción "{action}" ejecutada correctamente',
      error_executing: "Error al ejecutar la acción",
    },
    table_refreshed: "Tabla actualizada correctamente",
    warning: {
      title: "Advertencia",
    },
  },
};
